import React, {useState} from 'react';

import {Select} from '@kit';

import {useCharacter} from '../character-context';
import {sizeLabel} from '../model/labels';
import {formatFeet} from '../sheet/format';
import {FeatureDetails} from './feature-details';
import {PickList} from './pick-list';
import {SelectedTitle} from './step-layout';

export const SpecieStep: React.FC = () => {
	const {catalog, state, features, character, update} = useCharacter();
	const [isPicking, setPicking] = useState(false);
	const specie = state.specieId ? catalog.getSpecie(state.specieId) : undefined;

	const selectSpecie = (specieId: string) => {
		update({specieId, size: undefined});
		setPicking(false);
	};

	return (
		<>
			{!specie || isPicking ? (
				<PickList
					items={catalog.species.map((entry) => ({
						id: entry.id,
						title: entry.title,
						caption: `Скорость ${formatFeet(entry.speed)} • ${entry.sizes.map(sizeLabel).join(' или ')}`,
					}))}
					selectedId={specie?.id}
					onSelect={selectSpecie}
				/>
			) : (
				<>
					<SelectedTitle title={specie.title} backLabel="К списку видов" onBack={() => setPicking(true)} />
					{specie.sizes.length > 1 && (
						<Select
							label="Размер"
							disableClear
							items={specie.sizes.map((size) => ({value: size, label: sizeLabel(size)}))}
							value={character.size}
							onChange={([size]) => update({size: String(size)})}
						/>
					)}
					{features.specie.map((instance) => (
						<FeatureDetails key={instance.key} instance={instance} />
					))}
				</>
			)}
		</>
	);
};
